'use strict';

require('../../style/index.less');

require('./index.less');

require('./widget.less');


/*****************
 ** WEBPACK FOOTER
 ** ./components/card/style/index.js
 ** module id = 173
 ** module chunks = 0
 **/